import { render, staticRenderFns } from "./InstanceUrgent.vue?vue&type=template&id=69b40557&scoped=true&"
import script from "./InstanceUrgent.vue?vue&type=script&lang=js&"
export * from "./InstanceUrgent.vue?vue&type=script&lang=js&"
import style0 from "./InstanceUrgent.vue?vue&type=style&index=0&id=69b40557&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b40557",
  null
  
)

export default component.exports